import React from 'react'
import LivePage from '../LivePage/LivePage'

/**
 * AMAPage - Thin wrapper around LivePage that sets eventType to 'AMA'
 *
 * This component reuses all the functionality from LivePage but ensures
 * only AMA events are fetched and displayed.
 */
const AMAPage = (props) => {
  return <LivePage {...props} eventType="AMA" />
}

export default AMAPage
